<template>
  <TeamStatusControl :subject="slide.uuid" type="values"></TeamStatusControl>
</template>

<script>
import BaseSlide from './BaseSlide';
import TeamStatusControl from "../controls/TeamStatusControl";

export default {
	name: 'ChooseValuesSlide',
	mixins: [BaseSlide],
  components: {
    TeamStatusControl,
  },
};
</script>

<style></style>
